import React from 'react';
import styles from './index.css';

const QRCODE_URL = 'https://x0.ifengimg.com/ucms/2026_37/EC2D88D9FED3113682F9D5D46ABD7099FD688E4B_size11_w400_h400.png';
const FINANCE_AD_PIC_ID = 'bailingComplaintAdPic';

class QrMask extends React.PureComponent {
    state = {
        visible: false,
    };

    componentDidMount() {
        document.addEventListener('click', this.handleFinanceAdPicClick, true);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleFinanceAdPicClick, true);
    }

    findFinanceAdPic = (node) => {
        let current = node;

        while (current && current !== document) {
            if (current.id === FINANCE_AD_PIC_ID) {
                return current;
            }

            current = current.parentElement;
        }

        return null;
    };

    handleFinanceAdPicClick = (e) => {
        if (!this.findFinanceAdPic(e.target)) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        this.open();
    };

    open = () => {
        this.setState({ visible: true });
    };

    close = () => {
        this.setState({ visible: false });
    };

    preventClose = (e) => {
        e.stopPropagation();
    };

    render() {
        const { visible } = this.state;

        if (!visible) {
            return null;
        }

        return (
            <div className={styles.qrMask} onClick={this.close}>
                <div className={styles.qrMaskContent} onClick={this.preventClose}>
                    <div className={styles.qrMaskPanel}>
                        <div className={styles.qrMaskHead}>
                            <div className={styles.qrMaskHeadTitle}>百灵投诉</div>
                            <div className={styles.qrMaskHeadSub}>投资、理财、买保险遇陷阱来百灵投诉</div>
                        </div>
                        <div className={styles.qrMaskBody}>
                            <div className={styles.qrMaskQrWrap}>
                                <img className={styles.qrMaskImage} src={QRCODE_URL} alt="百灵小程序二维码" />
                            </div>
                            <div className={styles.qrMaskTip}>请使用手机扫码进入百灵小程序</div>
                        </div>
                    </div>
                    <div className={styles.qrMaskClose} onClick={this.close} />
                </div>
            </div>
        );
    }
}

export default QrMask;
